module.exports = __webpack_public_path__ + "static/media/grab_lg.5a3cba65.jpg";